import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SessionIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M17,5H4A2,2,0,0,0,2,7v7.9a2,2,0,0,0,2,2h7.46A6.37,6.37,0,0,1,11,14.5,6.5,6.5,0,0,1,17.5,8a6.16,6.16,0,0,1,1.5.18V7A2,2,0,0,0,17,5ZM4.5,8A.5.5,0,1,1,5,7.5.5.5,0,0,1,4.5,8Zm2,0A.5.5,0,1,1,7,7.5.5.5,0,0,1,6.5,8Zm2,0A.5.5,0,1,1,9,7.5.5.5,0,0,1,8.5,8Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.5,10A4.5,4.5,0,1,0,22,14.5,4.49,4.49,0,0,0,17.5,10Zm1.89,6.39a.44.44,0,0,1-.32.13.45.45,0,0,1-.32-.13l-1.7-1.7V11.8a.45.45,0,0,1,.9,0v2.51l1.44,1.44A.47.47,0,0,1,19.39,16.39Z"
  })]
}), 'SessionIcon');